// @flow strict

import * as React from 'react';
import classnames from '@ta/common.classnames';
import Icon from '@ta/core-ui.icon';
import type { IconHoverColorType } from './OverflowUI';

import styles from './OverflowIcon.css';

type Props = {|
  onClick: (event: SyntheticMouseEvent<*>) => mixed,
  color?: 'GREEN' | 'GRAY' | 'WHITE',
  hoverColor?: ?IconHoverColorType,
|};

// eslint-disable-next-line react/display-name
const OverflowIcon = React.forwardRef<Props, HTMLSpanElement>(
  ({ onClick, hoverColor, color = 'GRAY' }: Props, ref) => (
    <span
      className={classnames(styles.icon, {
        [styles.green]: color === 'GREEN',
        [styles.gray]: color === 'GRAY',
        [styles.white]: color === 'WHITE',
        [styles.whiteHover]: hoverColor === 'WHITE',
        [styles.greenHover]: hoverColor === 'GREEN',
      })}
      ref={ref}
      onClick={onClick}
    >
      <Icon name="more-horizontal" />
    </span>
  ),
);

export default OverflowIcon;
